import React, { useState, useEffect } from "react";
import "./orders.scss";
import Header from "../header/Header";
import List from "../../../components/list/List";
import { useHistory } from "react-router-dom";
import Titlebar from "../../../components/titlebar/Titlebar";
import { getUserOrderHistory } from "../../../utils/apis/services/api";
import Pagination from "react-js-pagination";
import ContentLoader from "react-content-loader";
import translate from "../../../utils/locale/language";
import { setDriverSelection,getDriverSelection,setPageSelection,getPageSelection} from "../../../../src/utils/common"

/* eslint-disable react-hooks/exhaustive-deps */
const Orders = () => {
  const [list, setList] = useState(1);
  const [justBuyList, setjustBuy] = useState([]);
  const [justSendList, setjustSend] = useState([]);
  const [requestListTmpjustBuy, setRequestListTmpBuy] = useState([]);
  const [requestListTmpjustSend, setRequestListTmpSend] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  var [activePage, setPage] = useState(1);

  const history = useHistory();

  const mapOrderHistoryItem = (item) => ({
    order_id: item?.order_id,
    created_by: item?.created_by || "",
    status: item?.status || "",
    total_amount: item?.total_amount || "0",
    preferred_currency: item?.preferred_currency || "",
    driver_details: {
      driver_full_name: item?.driver_assigned?.full_name || item?.created_by || "",
      driver_profile_image_url: ""
    },
    product_name: item?.product_name || "",
    created_at: item?.created_at || "",
    user_email: item?.driver_assigned?.email || ""
  });

  const filterOrders = (arr, text) => {
    if (!text) return arr;
    const q = text.toLowerCase();
    return arr.filter((item) => {
      const orderId = String(item?.order_id || "");
      const user = String(item?.created_by || "");
      const user_email = String(item?.driver_assigned?.email || "");
      const driver = String(item?.driver_details?.driver_full_name || "");
      const status = String(item?.status || "");
      const product = String(item?.product_name || "");
      return (
        orderId.toLowerCase().includes(q) ||
        user.toLowerCase().includes(q) ||
        driver.toLowerCase().includes(q) ||
        status.toLowerCase().includes(q) ||
        product.toLowerCase().includes(q) ||
        user_email.toLowerCase().includes(q)
      );
    });
  };

  const getjustSendList = async (page_number) => {
    const page = page_number || getPageSelection() || 1;
    setPageSelection(page);
    setLoading(true);
    let result = await getUserOrderHistory(page);
    setLoading(false);
    let results = result?.data?.ResponseData?.results || [];
    let mapped = Array.isArray(results) ? results.map(mapOrderHistoryItem) : [];
    let total = Number(result?.data?.ResponseData?.count) || mapped.length || 0;
    setCount(total);
    const tmp = { results: mapped, totalCount: total };
    setjustSend(mapped);
    setRequestListTmpSend(tmp);
    setjustBuy(mapped);
    setRequestListTmpBuy(tmp);
  };
  const getjustBuyList = async (page_number) => {
    const page = page_number || getPageSelection() || 1;
    setPageSelection(page);
    setLoading(true);
    let result = await getUserOrderHistory(page);
    setLoading(false);
    let results = result?.data?.ResponseData?.results || [];
    let mapped = Array.isArray(results) ? results.map(mapOrderHistoryItem) : [];
    let total = Number(result?.data?.ResponseData?.count) || mapped.length || 0;
    setCount(total);
    const tmp = { results: mapped, totalCount: total };
    setjustBuy(mapped);
    setRequestListTmpBuy(tmp);
    setjustSend(mapped);
    setRequestListTmpSend(tmp);
  };

  const updateInput = async (input) => {
    setInput(input);
    const base = list === 1 ? requestListTmpjustSend : requestListTmpjustBuy;
    const baseArr = Array.isArray(base) ? base : (base?.results || []);
    const baseTotal = base?.totalCount ?? baseArr.length;
    if (!input || input.length < 1) {
      setCount(baseTotal);
      if (list === 1) setjustSend(baseArr);
      else setjustBuy(baseArr);
      return;
    }
    const filtered = filterOrders(baseArr, input);
    setCount(filtered.length);
    if (list === 1) setjustSend(filtered);
    else setjustBuy(filtered);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
    setPageSelection(pageNumber);
    if (list === 1) {
      getjustSendList(pageNumber);
    } else if(list===2) {
      getjustBuyList(pageNumber);
    }
  };

  // useEffect(() => {
  //   getjustSendList(1);
  //   getjustBuyList(1);
  // }, []);

  // useEffect(() => {
  //   getjustSendList(1);
  //   getjustBuyList(1);
  // }, [history.location.state]);

  const handleRequestData = (data)=>{
    switch (data){
      case 1 :
        getjustSendList(getPageSelection());
        break;
      case 2:
        getjustBuyList(getPageSelection());
        break;   
      default:
        break;
  }
}

useEffect(()=>{
  const sideTab=localStorage.getItem("navOption");
  if(sideTab!=="/orders"){
      setDriverSelection(1)
      setPageSelection(1)
      setList(1)
      setPage(1)
      getjustSendList(1);
  }
},[])

// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  if(getPageSelection()){
    setPage(getPageSelection())
  }else{
    setPageSelection(1)
    setList(1)
    getjustSendList(1);
  }
  if(getDriverSelection()){
    setList(getDriverSelection())
    handleRequestData(parseInt(getDriverSelection()))  
  }else{
    setList(1)
    setDriverSelection(1)
  }
  setList(getDriverSelection())
}, [])

  const JustSend = () => {
    setList(1);
    setInput("");
    setPageSelection(1);
    getjustSendList(1);
    setDriverSelection(1);
    setPage(1)
  };
  const JustBuy = () => {
    setList(2);
    setInput("");
    setPageSelection(1);
    getjustBuyList(1);
    setDriverSelection(2);
    setPage(1)
  };

  const ordersList = (selected) => {
    switch (selected) {
      case 1:
        return (
          <List
            from="orders"
            data={justSendList}
            onClick={() => history.push("/orders/details")}
          />
        );
      case 2:
        return (
          <List
            from="orders"
            data={justBuyList}
            onClick={() => history.push("/orders/details")}
          />
        );
      default:
        return (
          <List
            from="orders"
            data={justSendList}
            onClick={() => history.push("/orders/details")}
          />
        );
    }
  };

  let loadshimmer = (
    <ContentLoader
      speed={2}
      width={"1000px"}
      height={450}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      style={{ marginLeft: -29, marginTop: -25 }}
    >
      <rect x="51" y="45" rx="3" ry="3" width="1006" height="17" />
      <circle cx="879" cy="123" r="11" />
      <circle cx="914" cy="123" r="11" />
      <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
      <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
      <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
      <rect x="55" y="155" rx="3" ry="3" width="997" height="2" />
      <circle cx="880" cy="184" r="11" />
      <circle cx="915" cy="184" r="11" />
      <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
      <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
      <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
      <rect x="56" y="216" rx="3" ry="3" width="997" height="2" />
      <circle cx="881" cy="242" r="11" />
      <circle cx="916" cy="242" r="11" />
      <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
      <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
      <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
      <rect x="57" y="274" rx="3" ry="3" width="997" height="2" />
      <circle cx="882" cy="303" r="11" />
      <circle cx="917" cy="303" r="11" />
      <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
      <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
      <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
      <rect x="58" y="335" rx="3" ry="3" width="997" height="2" />
      <circle cx="881" cy="363" r="11" />
      <circle cx="916" cy="363" r="11" />
      <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
      <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
      <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
      <rect x="57" y="395" rx="3" ry="3" width="997" height="2" />
      <circle cx="882" cy="424" r="11" />
      <circle cx="917" cy="424" r="11" />
      <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
      <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
      <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
      <rect x="55" y="453" rx="3" ry="3" width="997" height="2" />
      <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
      <rect x="997" y="49" rx="3" ry="3" width="2" height="465" />
      <circle cx="882" cy="484" r="11" />
      <circle cx="917" cy="484" r="11" />
      <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
      <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
      <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
      <rect x="55" y="513" rx="3" ry="3" width="997" height="2" />
      <rect x="52" y="80" rx="3" ry="3" width="1006" height="17" />
      <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
      <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
      <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
      <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
      <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
    </ContentLoader>
  );

  return (
    <div className="drivers">
      <Header title={translate("orders")} />
      <div className="drivers-header">
        <p className="partner-database">
          {/* {translate("ordersDatabase")}  */}
        </p>
      </div>
      <Titlebar
        onClick1={JustSend}
        onClick2={JustBuy}
        input={input}
        onClick4={updateInput}
        active={list}
        title1={translate("justsend2")}
      />
        {/* title2={translate("justbuy2")} */}

      {!loading ? (
        <div>
          <section className="shortlisted">{ordersList(list)}</section>
          {count > 10 ? (
            <div className="campaign-pagination-bottom" style={{ justifyContent: 'flex-end' }}>
              <Pagination
                firstPageText={
                  <i className="fa fa-angle-left" aria-hidden="true"></i>
                }
                prevPageText={
                  <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                }
                lastPageText={
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                }
                nextPageText={
                  <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                }
                activePage={activePage}
                itemsCountPerPage={10}
                totalItemsCount={count}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                activeClass="active"
                activeLinkClass="active"
                hideDisabled
              />
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        <section className="shortlisted">{loadshimmer}</section>
      )}
    </div>
  );
};
export default Orders;
